'use strict';
const TOLERANCE = 3;

module.exports = function gridDown(domElement) {
	const elementPos = domElement.getBoundingClientRect(),
		siblings = Array.from(domElement.parentElement.children).filter(t => t !== domElement),
		siblingsBelow = siblings.filter(sibling => {
			const position = sibling.getBoundingClientRect();
			return elementPos.top < position.top && Math.abs(elementPos.left - position.left) < TOLERANCE;
		});
	siblingsBelow.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
	return siblingsBelow[0] || domElement;
};

